module.exports = __webpack_public_path__ + "img/deepwater-green2.12589596.png";